import * as ng from 'angular';
import { PostRepeatDirective } from './post-repeat-directive.directive';

export const PostRepeatDirectiveModule: string =
    ng.module('post-repeat-directive', [
    ])
        .directive('postRepeatDirective', PostRepeatDirective)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/post-repeat-directive/post-repeat-directive.module.ts